$(function () {

    // Переключение по неделям
    $(document).on('click', '.schedule-switch__next, .schedule-switch__prev', function () {

    });


});